<template>
  <div class="protocol">
    <h1>尊敬的{{this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '才博'}}用户</h1>
    <p>感谢您申请使用珠海金山办公软件有限公司（以下简称为“金山办公”）为您提供的自动续费委托扣款服务（以下简称为“本服务”），请您仔细阅读并同意《金山办公自动续费服务协议》（以下简称为“本协议”）。本协议是出于{{this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '才博'}}畅学卡会员对于自动续费的需求，避免畅学卡会员因疏忽或其他原因导致未能及时续费造成损失而推出的，请您务必仔细阅读本规则，如您选择使用好好学习连续包月/包年服务，视为您已充分理解并同意下述使用规则：</p>
    <p>1. 本服务是在您已开通{{this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '才博'}}畅学卡会员服务的前提下，为您提供的自动续费服务。如您开通本服务，则视为您授权{{this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '才博'}}畅学卡的运营方珠海金山办公软件有限公司（以下简称“金山办公”）有权在您的{{this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '才博'}}畅学卡会员服务周期即将到期时，从您的自有充值账户、与会员账号绑定的第三方支付账户、iTunes账户（以下统称“账户”）余额中代扣下一个服务周期的服务费。计费周期包括但不限于月度、年度等（下同），会员可根据{{this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '才博'}}平台上显示的计费周期自行选择。该服务实现的前提是会员已将其{{this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '才博'}}畅学卡账号与上述账户绑定，且可成功从其上述账户中扣款。</p>
    <p>2.自动续费具体指，基于2.1的前提，{{this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '才博'}}通过上述账户收取会员下一计费周期费用的扣费方式，会员需保证{{this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '才博'}}可以从上述账户扣款成功，因上述账户中可扣款余额不足导致的续费失败，由会员自行承担责任。</p>
    <p>3.{{this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '才博'}}负责向畅学卡会员提供有关自动续费收费具体情况的查询方式，但不负责打印相关发票并转送会员。{{this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '才博'}}通过会员上述账户扣除下一计费周期费用的，应于开通自动续费约定时间划扣，并将款项记入会员支付记录，并同时相应延长会员有效期。</p>
    <p>4.如在扣费过程出现差错，{{this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '才博'}}方和会员方应密切配合查明原因，各自承担己方过错造成的损失；若因双方各自存在不均等过错造成损失的，由双方按过错的程度承担相应责任；因双方共同过错造成损失但无法区分各自过错的，由双方均摊责任。</p>
    <p>5.{{this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '才博'}}可根据其业务开展或技术升级等情况变更或修改本协议的有关服务内容、规则及条款，{{this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '才博'}}将通过在{{this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '才博'}}相关页面公示的方式告知用户相关变更或修改内容，但无义务另行做个别通知。如果会员不同意本协议的修改，可以取消已经获取的本服务并停止使用；如果会员继续使用{{this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '才博'}}提供的服务，则视为会员已经接受本协议的全部修改。
    </p>
    <p>6.本服务由会员自主选择是否取消，若会员选择不取消，则视为会员同意{{this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '才博'}}按照一定规则进行扣款尝试，一旦扣款成功，{{this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '才博'}}将为会员开通下一个计费周期的会员服务。若在自动续费时/之前，{{this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '才博'}}服务价格发生调整，应以现时有效的价格为准。
    </p>
    <p>7.{{this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '才博'}}对会员开通本服务不收取任何费用，但{{this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '才博'}}有权根据业务需要或市场变化等原因决定是否对本服务本身进行收费或调整自动续费周期及费用，并在相关页面向会员进行公示。
    </p>
    <p>8.本协议自会员选择接受或使用本服务后生效，直至会员终止本服务/注销会员资格时终止。会员有权随时在会员账号设置中选择终止本服务，终止本服务后，{{this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '才博'}}将停止向会员提供本服务。{{this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '才博'}}特别提醒用户：当用户开通使用自动续费服务后，即委托{{this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '才博'}}在用户默认的支付渠道进行扣款，金山办公将视为用户选择认购了{{this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '才博'}}的相关付费服务，金山办公将不以任何方式对用户所支付的费用予以退还。</p>
    <p>9.会员在选择终止本服务前已经委托{{this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '才博'}}自动续费扣款的指令仍然有效，{{this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '才博'}}对于基于该指令扣除的费用不予退还，由会员承担相关责任。</p>
    <p>10.您可通过下述方式取消自动续费服务，取消续费服务的，需在会员每个服务周期届满至少24小时前取消，否则视为您同意继续授权自动续费。</p>
    <p>用户取消自动续费服务的方法如下：</p>
    <p>1. 打开微信 app ：我的 - 钱包 - 项目管理 - 自动扣款 - 选择「{{this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '才博'}}」- 取消
    </p>
    <p>您点击“开通”或“续费”按钮同意本服务规则之时，为本规则对您的生效时间。
    </p>
  </div>
</template>

<script>
  export default {
    computed: {
    },
    methods: {
    },
    beforeCreate () {
    },
    mounted () {
      window.scrollTo(0, 0)
    },
    created () {
    },
    beforeDestroy () {
    },
    components: {

    }
  }
</script>

<style lang="scss">
  @charset "UTF-8";
  @import "../../style/main";

  .protocol {
    line-height: 2;
    font-size: rem(22);
    padding: rem(10);
    h1 {
      text-align: center;
      font-size: rem(26);
    }
    h2, p {
      text-align: left;
    }
  }
</style>
